import React from 'react';

import { ChargingStationInterFace } from '../../../interface/charging-station.interface';

import ApprovedElectricityPrice from './ApprovedElectricityPrice';
import ApprovedStationList from './ApprovedStationList';

interface UnapprovedListingProperties {
  viewFunction: (value: ChargingStationInterFace) => void;
  currentPage: string;
  setCurrentPage: (value: string) => void;
  handleDeleteStationWarning: (value: string | undefined) => void;
}

/**
 * Function to toggle between unapproved station and unapproved electric price
 * @returns
 */
function ApprovedListing(properties: UnapprovedListingProperties) {
  const { currentPage, setCurrentPage, handleDeleteStationWarning } = properties;

  return (
    <div className="unapproved-list-toggle-wrap">
      {currentPage === 'station' && (
        <ApprovedStationList
          handleDeleteStationWarning={handleDeleteStationWarning}
        />
      )}
      {currentPage === 'electricityPrice' && (
        <ApprovedElectricityPrice currentPage={currentPage} setCurrentPage={setCurrentPage} />
      )}
    </div>
  );
}

export default ApprovedListing;
